<template>
  <div class="parties-manage">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>收发通管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="main">
      <el-tabs v-model="activeTab" @tab-click="onTabClick">
        <el-tab-pane
          v-for="t in tabs"
          :key="t.key"
          :label="t.label"
          :name="t.key"
        />
      </el-tabs>

      <div class="toolbar clearfix">
        <el-input
          v-model="inputVal"
          placeholder="按名称查询"
          clearable
          style="width: 220px; margin-right: 8px"
        />
        <el-button type="primary" size="small" @click="queryList">查询</el-button>
        <el-button type="primary" @click="openAdd">添加{{ currentMeta.label }}</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          v-for="col in currentMeta.columns"
          :key="col.prop"
          :label="col.label"
          :prop="col.prop"
          :min-width="col.minWidth || 90"
        />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <el-dialog
        :title="(isAdd ? '新增' : '修改') + currentMeta.label"
        :visible.sync="dialogVisible"
        :before-close="closeDialog"
        :close-on-click-modal="false"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="formRules"
          label-width="110px"
        >
          <el-form-item :label="currentMeta.label" prop="name">
            <el-input v-model="ruleForm.name" @blur="fillEnameIfEmpty" />
          </el-form-item>
          <el-form-item label="英文名称" prop="ename">
            <el-input v-model="ruleForm.ename" placeholder="默认与中文名相同，可改" />
          </el-form-item>

          <!-- 进口商 -->
          <template v-if="activeTab === 'importer'">
            <el-form-item label="国家" prop="country">
              <country :countrys="ruleForm.country" @getCty="getCountry" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.vatLabel" prop="vat">
              <el-input v-model="ruleForm.vat" :placeholder="importerTaxMeta.vatPlaceholder" />
            </el-form-item>
            <el-form-item v-if="importerTaxMeta.showEori" :label="importerTaxMeta.eoriLabel" prop="eori">
              <el-input v-model="ruleForm.eori" :placeholder="importerTaxMeta.eoriPlaceholder" />
            </el-form-item>
            <el-form-item v-if="importerTaxMeta.showIoss" label="IOSS" prop="ioss">
              <el-input v-model="ruleForm.ioss" placeholder="欧盟 IOSS，常见 IM 开头" />
            </el-form-item>
            <template v-if="importerTaxMeta.showBond">
              <el-form-item label="保函类型" prop="bondType">
                <el-select v-model="ruleForm.bondType" clearable placeholder="选填" style="width:80%">
                  <el-option label="连续保函 continuous" value="continuous" />
                  <el-option label="单票 single" value="single" />
                  <el-option label="无 none" value="none" />
                </el-select>
              </el-form-item>
              <el-form-item label="保函号" prop="bondNo">
                <el-input v-model="ruleForm.bondNo" placeholder="美国 Bond 号" />
              </el-form-item>
            </template>
            <el-form-item v-if="importerTaxMeta.showIe" label="IE" prop="ie">
              <el-input v-model="ruleForm.ie" placeholder="巴西州登记号 IE" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.stateLabel" prop="state">
              <el-input v-model="ruleForm.state" :placeholder="importerTaxMeta.statePlaceholder" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.cityLabel" prop="city">
              <el-input v-model="ruleForm.city" :placeholder="importerTaxMeta.cityPlaceholder" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.zipLabel" prop="zip">
              <el-input v-model="ruleForm.zip" :placeholder="importerTaxMeta.zipPlaceholder" />
            </el-form-item>
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="ruleForm.contact" />
            </el-form-item>
            <el-form-item label="电话" prop="tel">
              <el-input v-model="ruleForm.tel" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input type="textarea" v-model="ruleForm.address" />
            </el-form-item>
          </template>

          <!-- 发货人 -->
          <template v-else-if="activeTab === 'shipper'">
            <el-form-item label="国家" prop="country">
              <country :countrys="ruleForm.country" @getCty="getCountry" />
            </el-form-item>
            <el-form-item label="州/省" prop="state">
              <el-input v-model="ruleForm.state" />
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-input v-model="ruleForm.city" />
            </el-form-item>
            <el-form-item label="邮编" prop="zip">
              <el-input v-model="ruleForm.zip" />
            </el-form-item>
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="ruleForm.contact" />
            </el-form-item>
            <el-form-item label="电话" prop="tel">
              <el-input v-model="ruleForm.tel" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input type="textarea" v-model="ruleForm.address" />
            </el-form-item>
          </template>

          <!-- 供应商 -->
          <template v-else-if="activeTab === 'supplier'">
            <el-form-item label="国家" prop="country">
              <country :countrys="ruleForm.country" @getCty="getCountry" />
            </el-form-item>
            <el-form-item label="州/省" prop="state">
              <el-input v-model="ruleForm.state" />
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-input v-model="ruleForm.city" />
            </el-form-item>
            <el-form-item label="邮编" prop="zip">
              <el-input v-model="ruleForm.zip" />
            </el-form-item>
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="ruleForm.contact" />
            </el-form-item>
            <el-form-item label="联系方式" prop="tel">
              <el-input v-model="ruleForm.tel" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input type="textarea" v-model="ruleForm.address" />
            </el-form-item>
          </template>

          <!-- 收货人 -->
          <template v-else-if="activeTab === 'consignee'">
            <el-form-item label="国家" prop="country">
              <country :countrys="ruleForm.country" @getCty="getCountry" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.vatLabel" prop="vat">
              <el-input v-model="ruleForm.vat" :placeholder="importerTaxMeta.vatPlaceholder + '（选填）'" />
            </el-form-item>
            <el-form-item v-if="importerTaxMeta.showEori" label="EORI" prop="eori">
              <el-input v-model="ruleForm.eori" :placeholder="importerTaxMeta.eoriPlaceholder" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.stateLabel" prop="state">
              <el-input v-model="ruleForm.state" />
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-input v-model="ruleForm.city" />
            </el-form-item>
            <el-form-item :label="importerTaxMeta.zipLabel" prop="zip">
              <el-input v-model="ruleForm.zip" />
            </el-form-item>
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="ruleForm.contact" />
            </el-form-item>
            <el-form-item label="电话" prop="tel">
              <el-input v-model="ruleForm.tel" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input type="textarea" v-model="ruleForm.address" />
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm">{{ isAdd ? "添 加" : "修 改" }}</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import httpApi from "@/http/api";
import Country from "@/components/Country";
import {
  resolveImporterTaxMeta,
  validateImporterTaxFields
} from "@/utils/importerTax";

const TAB_META = {
  shipper: {
    key: "shipper",
    label: "发货人",
    type: "1",
    columns: [
      { label: "发货人", prop: "name" },
      { label: "英文名称", prop: "ename" },
      { label: "国家", prop: "country" },
      { label: "城市", prop: "city" },
      { label: "联系人", prop: "contact" },
      { label: "电话", prop: "tel" },
      { label: "邮箱", prop: "email" },
      { label: "地址", prop: "address", minWidth: 160 }
    ]
  },
  importer: {
    key: "importer",
    label: "进口商",
    type: "0",
    columns: [
      { label: "进口商", prop: "name" },
      { label: "国家", prop: "country" },
      { label: "税号", prop: "vat" },
      { label: "EORI", prop: "eori" },
      { label: "IOSS", prop: "ioss" },
      { label: "保函号", prop: "bondNo" },
      { label: "IE", prop: "ie" },
      { label: "城市", prop: "city" },
      { label: "联系人", prop: "contact" },
      { label: "电话", prop: "tel" },
      { label: "邮箱", prop: "email" },
      { label: "地址", prop: "address", minWidth: 140 }
    ]
  },
  supplier: {
    key: "supplier",
    label: "供应商",
    type: "2",
    columns: [
      { label: "供应商", prop: "name" },
      { label: "国家", prop: "country" },
      { label: "城市", prop: "city" },
      { label: "联系人", prop: "contact" },
      { label: "电话", prop: "tel" },
      { label: "邮箱", prop: "email" },
      { label: "地址", prop: "address", minWidth: 160 }
    ]
  },
  consignee: {
    key: "consignee",
    label: "收货人",
    type: "3",
    columns: [
      { label: "收货人", prop: "name" },
      { label: "国家", prop: "country" },
      { label: "税号", prop: "vat" },
      { label: "城市", prop: "city" },
      { label: "州/省", prop: "state" },
      { label: "邮编", prop: "zip" },
      { label: "联系人", prop: "contact" },
      { label: "电话", prop: "tel" },
      { label: "邮箱", prop: "email" },
      { label: "地址", prop: "address", minWidth: 140 }
    ]
  }
};

function emptyForm() {
  return {
    id: null,
    name: "",
    ename: "",
    contact: "",
    tel: "",
    email: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zip: "",
    eori: "",
    vat: "",
    taxIdType: "",
    ioss: "",
    bondType: "",
    bondNo: "",
    ie: ""
  };
}

export default {
  name: "PartiesManage",
  components: { Country },
  data() {
    return {
      tabs: [
        TAB_META.shipper,
        TAB_META.importer,
        TAB_META.supplier,
        TAB_META.consignee
      ],
      activeTab: "shipper",
      tableData: [],
      inputVal: "",
      currentPage: 1,
      pagesize: 20,
      total: 0,
      dialogVisible: false,
      isAdd: true,
      editIndex: 0,
      ruleForm: emptyForm()
    };
  },
  computed: {
    currentMeta() {
      return TAB_META[this.activeTab] || TAB_META.shipper;
    },
    importerTaxMeta() {
      return resolveImporterTaxMeta(this.ruleForm.country);
    },
    formRules() {
      const label = this.currentMeta.label;
      const base = {
        name: [{ required: true, message: `请输入${label}`, trigger: "blur" }],
        ename: [{ required: true, message: "请输入英文名称", trigger: "blur" }]
      };
      if (this.activeTab === "importer") {
        const tax = this.importerTaxMeta;
        return {
          ...base,
          country: [{ required: true, message: "请选择国家", trigger: "change" }],
          vat: [{ required: true, message: `请输入${tax.vatLabel}`, trigger: "blur" }],
          state: [{ required: true, message: `请输入${tax.stateLabel}`, trigger: "blur" }],
          city: [{ required: true, message: "请输入城市", trigger: "blur" }],
          zip: [{ required: true, message: `请输入${tax.zipLabel}`, trigger: "blur" }],
          contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          tel: [{ required: true, message: "请输入电话", trigger: "blur" }],
          email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }]
        };
      }
      if (this.activeTab === "shipper") {
        return {
          ...base,
          contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          tel: [{ required: true, message: "请输入电话", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }]
        };
      }
      if (this.activeTab === "supplier") {
        return {
          ...base,
          contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }]
        };
      }
      return {
        ...base,
        country: [{ required: true, message: "请选择国家", trigger: "change" }],
        state: [{ required: true, message: "请输入州/省", trigger: "blur" }],
        zip: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        tel: [{ required: true, message: "请输入电话", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      };
    }
  },
  watch: {
    "$route.query.tab"(val) {
      const prev = this.activeTab;
      this.syncTabFromRoute(val);
      if (this.activeTab !== prev) {
        this.currentPage = 1;
        this.inputVal = "";
        this.queryList();
      }
    }
  },
  created() {
    this.syncTabFromRoute(this.$route.query.tab);
    this.queryList();
  },
  methods: {
    syncTabFromRoute(tab) {
      this.activeTab = tab && TAB_META[tab] ? tab : "shipper";
    },
    onTabClick() {
      this.currentPage = 1;
      this.inputVal = "";
      this.$router.replace({ path: "/parties", query: { tab: this.activeTab } });
      this.queryList();
    },
    fillEnameIfEmpty() {
      if (!this.ruleForm.ename && this.ruleForm.name) {
        this.ruleForm.ename = this.ruleForm.name;
      }
    },
    getCountry(e) {
      this.ruleForm.country = e;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate(["vat", "eori", "state", "zip", "ioss", "bondNo", "ie"]);
        }
      });
    },
    openAdd() {
      this.isAdd = true;
      this.ruleForm = emptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },
    closeDialog() {
      if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      this.dialogVisible = false;
    },
    handleEdit(index, row) {
      this.isAdd = false;
      this.editIndex = index;
      this.ruleForm = {
        ...emptyForm(),
        id: row.id,
        name: row.name || "",
        ename: row.ename || row.name || "",
        contact: row.contact || "",
        tel: row.tel || "",
        email: row.email || "",
        address: row.address || "",
        country: row.country || "",
        state: row.state || "",
        city: row.city || "",
        zip: row.zip || "",
        eori: row.eori || "",
        vat: row.vat || "",
        taxIdType: row.taxIdType || "",
        ioss: row.ioss || "",
        bondType: row.bondType || "",
        bondNo: row.bondNo || "",
        ie: row.ie || ""
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => httpApi.updateUser({ id: row.id }))
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("删除成功!");
            this.tableData.splice(index, 1);
            this.total = Math.max(0, this.total - 1);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    buildPayload() {
      this.fillEnameIfEmpty();
      const ename = (this.ruleForm.ename || this.ruleForm.name || "").trim();
      const meta = resolveImporterTaxMeta(this.ruleForm.country);
      const base = {
        name: this.ruleForm.name,
        ename,
        type: this.currentMeta.type,
        country: this.ruleForm.country || undefined,
        state: this.ruleForm.state || undefined,
        city: this.ruleForm.city || undefined,
        zip: this.ruleForm.zip || undefined,
        contact: this.ruleForm.contact || undefined,
        tel: this.ruleForm.tel || undefined,
        email: this.ruleForm.email || undefined,
        address: this.ruleForm.address || undefined
      };
      if (this.activeTab === "importer") {
        return {
          ...base,
          vat: this.ruleForm.vat,
          taxIdType: meta.taxIdType,
          eori: meta.showEori ? this.ruleForm.eori : this.ruleForm.eori,
          ioss: meta.showIoss ? this.ruleForm.ioss : this.ruleForm.ioss,
          bondType: meta.showBond ? this.ruleForm.bondType : this.ruleForm.bondType,
          bondNo: meta.showBond ? this.ruleForm.bondNo : this.ruleForm.bondNo,
          ie: meta.showIe ? this.ruleForm.ie : this.ruleForm.ie
        };
      }
      if (this.activeTab === "consignee") {
        return {
          ...base,
          vat: this.ruleForm.vat || undefined,
          taxIdType: this.ruleForm.vat ? meta.taxIdType : undefined,
          eori: this.ruleForm.eori || undefined
        };
      }
      return base;
    },
    submitForm() {
      this.fillEnameIfEmpty();
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return;
        if (this.activeTab === "importer") {
          const taxErr = validateImporterTaxFields(this.ruleForm);
          if (taxErr) {
            this.$message.error(taxErr);
            return;
          }
        }
        if (this.activeTab === "consignee" && this.ruleForm.vat) {
          const taxErr = validateImporterTaxFields(this.ruleForm);
          if (taxErr) {
            this.$message.error(taxErr);
            return;
          }
        }
        const payload = this.buildPayload();
        const req = this.isAdd
          ? httpApi.addUser(payload)
          : httpApi.modifyUser({ ...payload, id: this.ruleForm.id });
        req.then(res => {
          if (res.data.code === "ok") {
            this.$message.success(this.isAdd ? "添加成功！" : "修改成功！");
            this.dialogVisible = false;
            this.queryList();
          } else {
            this.$message.error(res.data.message || "操作失败");
          }
        });
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.queryList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      httpApi
        .queryUser({
          params: {
            page: this.currentPage,
            rows: this.pagesize,
            type: this.currentMeta.type,
            name: this.inputVal
          }
        })
        .then(res => {
          if (res.data.code === "ok") {
            this.tableData = res.data.data.rows || [];
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.toolbar {
  margin-bottom: 12px;
}
.block {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-dialog {
  width: 40% !important;
  min-width: 520px;
  .el-dialog__body {
    padding-bottom: 0;
    /deep/ .el-input,
    .el-textarea {
      float: left;
      width: 80%;
      .el-textarea__inner {
        height: 90px;
      }
    }
  }
  .el-dialog__footer .dialog-footer {
    margin-right: 35px;
  }
}
/deep/ .el-form-item__label {
  font-size: 13px;
}
/deep/ .el-select {
  width: 80%;
}
</style>
